import Icon from '../components/Icon.vue'

Icon.register({"money-bill-alt":{"width":640,"height":512,"paths":[{"d":"M352 288H336V200C336 195.6 332.4 192 328 192H314.4C309.7 192 305.1 193.4 301.1 196L285.8 206.3A8-8 0 0 1 283.6 217.3L292.4 230.7A8-8 0 0 1 303.5 232.9L304 232.6V288H288C283.6 288 280 291.6 280 296V312C280 316.4 283.6 320 288 320H352C356.4 320 360 316.4 360 312V296C360 291.6 356.4 288 352 288zM608 64H32C14.3 64 0 78.3 0 96V416C0 433.7 14.3 448 32 448H608C625.7 448 640 433.7 640 416V96C640 78.3 625.7 64 608 64zM48 400V336C83.3 336 112 364.6 112 400H48zM48 176V112H112C112 147.4 83.3 176 48 176zM320 368C267 368 224 317.9 224 256 224 194.1 267 144 320 144S416 194.1 416 256C416 317.9 373 368 320 368zM592 400H528C528 364.6 556.6 336 592 336V400zM592 176C556.6 176 528 147.4 528 112H592V176z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/money-bill-alt.js
// module id = ZIml
// module chunks = 0